import { render, staticRenderFns } from "./googlemeet-button.vue?vue&type=template&id=6b5020f1"
import script from "./googlemeet-button.vue?vue&type=script&lang=ts"
export * from "./googlemeet-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports